import React from "react";
import {Card, Col, Form, Row} from "react-bootstrap";

/**
 * Schritt 1 des Kampagnen-Assistenten: Name, Absender, Betreff. Das sind die
 * Angaben, die zum Anlegen der Kampagne (erstes Speichern) unbedingt
 * gebraucht werden.
 */
export default function StepGrunddaten({data, errors, handleChange, mailboxes}) {
    return (
        <Card>
            <Card.Body>
                <p className="text-muted">
                    Hier legst du fest, wie die Kampagne heißt (nur intern sichtbar),
                    von welchem Postfach die Mails verschickt werden und welchen
                    Betreff die Empfänger sehen.
                </p>

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Name der Kampagne</Form.Label>
                    <Col sm={9}>
                        <Form.Control id="name" value={data.name} onChange={handleChange}
                                      className={errors.name ? "is-invalid" : ""}/>
                        <Form.Text className="text-muted">
                            Nur für euch intern - taucht in keiner E-Mail auf.
                        </Form.Text>
                        {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Absender-Postfach</Form.Label>
                    <Col sm={9}>
                        <Form.Select id="sender_mailbox" value={data.sender_mailbox} onChange={handleChange}
                                     className={errors.sender_mailbox ? "is-invalid" : ""}>
                            <option value="">- bitte wählen -</option>
                            {(mailboxes ?? []).map((mailbox) => (
                                <option key={mailbox.id} value={mailbox.email}>
                                    {mailbox.display_name ? `${mailbox.display_name} <${mailbox.email}>` : mailbox.email}
                                </option>
                            ))}
                        </Form.Select>
                        <Form.Text className="text-muted">
                            Von diesem Postfach aus werden die E-Mails tatsächlich verschickt.
                        </Form.Text>
                        {errors.sender_mailbox && <div className="invalid-feedback d-block">{errors.sender_mailbox}</div>}
                        {(mailboxes ?? []).length === 0 && (
                            <div className="text-danger small mt-1">
                                Kein Absender freigegeben - unter „Absender-Postfächer" (Kampagnenliste) erst einen hinzufügen/freigeben.
                            </div>
                        )}
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Absender-Name</Form.Label>
                    <Col sm={9}>
                        <Form.Control id="sender_name" value={data.sender_name} onChange={handleChange}
                                      className={errors.sender_name ? "is-invalid" : ""}/>
                        <Form.Text className="text-muted">
                            So erscheint der Absender im Postfach des Empfängers, z. B. „Max Mustermann - MOLOTOW".
                        </Form.Text>
                        {errors.sender_name && <div className="invalid-feedback d-block">{errors.sender_name}</div>}
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Antworten an</Form.Label>
                    <Col sm={9}>
                        <Form.Control id="reply_to" value={data.reply_to} onChange={handleChange}
                                      className={errors.reply_to ? "is-invalid" : ""}/>
                        <Form.Text className="text-muted">
                            Antwortet der Empfänger, landet die Antwort hier (falls leer: im Absender-Postfach).
                        </Form.Text>
                        {errors.reply_to && <div className="invalid-feedback d-block">{errors.reply_to}</div>}
                    </Col>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label column sm={3}>Betreff</Form.Label>
                    <Col sm={9}>
                        <Form.Control id="subject" value={data.subject} onChange={handleChange}
                                      className={errors.subject ? "is-invalid" : ""}/>
                        {errors.subject && <div className="invalid-feedback d-block">{errors.subject}</div>}
                    </Col>
                </Form.Group>
            </Card.Body>
        </Card>
    );
}
